module.exports = "/static/assets/cec7826ea298dd0aed3a4c9cedaa3c71.png";